import { render, staticRenderFns } from "./pzTop.vue?vue&type=template&id=3aecb194&scoped=true&"
import script from "./pzTop.vue?vue&type=script&lang=ts&"
export * from "./pzTop.vue?vue&type=script&lang=ts&"
import style0 from "./pzTop.vue?vue&type=style&index=0&id=3aecb194&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aecb194",
  null
  
)

export default component.exports